import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Download } from "lucide-react";

export default function AdminNewsletter() {
  const [subs, setSubs] = useState([]);
  useEffect(() => { api.get("/admin/newsletter").then(r => setSubs(r.data)).catch(() => {}); }, []);
  const exportCSV = () => {
    const rows = [["email", "name", "source", "subscribed_at", "unsubscribed"]];
    subs.forEach(s => rows.push([s.email, s.name || "", s.source || "", s.subscribed_at, String(!!s.unsubscribed)]));
    const csv = rows.map(r => r.map(v => `"${v}"`).join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = `hearinsight-subscribers-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };
  return (
    <div data-testid="admin-newsletter-page">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="font-serif text-4xl text-[#1A1728]">Newsletter Subscribers</h1>
          <p className="text-[#5C5870] mt-1">{subs.length} email terdaftar</p>
        </div>
        <button onClick={exportCSV} className="lumina-btn-primary" disabled={subs.length === 0} data-testid="export-csv-btn">
          <Download className="w-4 h-4" /> Export CSV
        </button>
      </div>
      <div className="lumina-card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F1EBFA]/40 text-[#5C5870] text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-6 py-4">Email</th>
              <th className="text-left px-6 py-4">Nama</th>
              <th className="text-left px-6 py-4">Sumber</th>
              <th className="text-left px-6 py-4">Tanggal</th>
              <th className="text-left px-6 py-4">Status</th>
            </tr>
          </thead>
          <tbody>
            {subs.map(s => (
              <tr key={s.email} className="border-t border-[#E2DFED]">
                <td className="px-6 py-4 font-medium text-[#1A1728]">{s.email}</td>
                <td className="px-6 py-4 text-[#5C5870]">{s.name || "—"}</td>
                <td className="px-6 py-4 text-[#5C5870]"><span className="bg-[#E8F0FA] text-[#6B4BA3] px-2 py-1 rounded-full text-xs">{s.source}</span></td>
                <td className="px-6 py-4 text-[#5C5870]">{new Date(s.subscribed_at).toLocaleDateString("id-ID")}</td>
                <td className="px-6 py-4">{s.unsubscribed ? <span className="text-xs text-gray-500">unsubscribed</span> : <span className="text-xs text-green-700 font-medium">active</span>}</td>
              </tr>
            ))}
            {subs.length === 0 && (
              <tr><td colSpan={5} className="p-10 text-center text-[#5C5870]">Belum ada subscriber.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
